"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _spauiUtils = require("@tencent/spaui-utils");

var _spauiPopover = require("@tencent/spaui-popover");

var _index = require("../utils/index");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var tipDefaultOffsetData = {
  left: 5
};

var SelectionDataComponent =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(SelectionDataComponent, _React$PureComponent);

  function SelectionDataComponent(props) {
    var _this;

    _classCallCheck(this, SelectionDataComponent);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelectionDataComponent).call(this, props)); // 进行防抖处理，防止多次render，只需要处理最后一次（16ms是为了防止元素还没有完全渲染完，去获取高度信息有误）

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var _this$props = _this.props,
          open = _this$props.open,
          selectedValueAutoToView = _this$props.selectedValueAutoToView;

      if (open && selectedValueAutoToView) {
        _this.scrollChangeNodeToView();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentDidUpdate", function (prevProps) {
      var _this$props2 = _this.props,
          selectedValueAutoToView = _this$props2.selectedValueAutoToView,
          open = _this$props2.open;

      if (!prevProps.open && open && selectedValueAutoToView) {
        _this.scrollChangeNodeToView();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.nullList();
    });

    _defineProperty(_assertThisInitialized(_this), "nullList", function () {
      _this.scrollContainerEle = null;
    });

    _defineProperty(_assertThisInitialized(_this), "setScrollContainerRef", function (element) {
      var dataHtmlRef = _this.props.dataHtmlRef;
      _this.scrollContainerEle = element;

      if ((0, _spauiUtils.isFunction)(dataHtmlRef)) {
        dataHtmlRef(element);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "scrollChangeNodeToView", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          scrollContainerEle = _assertThisInitialize.scrollContainerEle;

      var _this$props3 = _this.props,
          valueFieldName = _this$props3.valueFieldName,
          value = _this$props3.value;
      var showData = (0, _index.getShowData)(_this.props);
      var firstSelectValue = [].concat(value)[0];

      if (_typeof(firstSelectValue) !== undefined && showData.length > 0 && scrollContainerEle) {
        // 获取第一个选中的值在展示数据中的索引
        var selectedIndex = showData.findIndex(function (item) {
          var itemValue = typeof item[valueFieldName] !== 'undefined' ? item[valueFieldName] : item;
          return itemValue === firstSelectValue;
        });

        if (selectedIndex < 0) {
          return;
        }

        var itemElement = scrollContainerEle.querySelector("li[data-index=\"".concat(selectedIndex, "\"]"));

        if (itemElement) {
          var itemOffsetTop = itemElement.offsetTop;
          var itemOffsetHeight = itemElement.offsetHeight;
          var viewOffsetTop = scrollContainerEle.scrollTop;
          var scrollContainerHeight = scrollContainerEle.offsetHeight;
          var viewOffsetBottom = viewOffsetTop + scrollContainerHeight; // 如果不在滚动区域内, 调整滚动距离到该元素出现在顶部

          if (!(itemOffsetTop >= viewOffsetTop && itemOffsetTop <= viewOffsetBottom)) {
            scrollContainerEle.scrollTop = itemOffsetTop - scrollContainerHeight / 2 - itemOffsetHeight / 2;
          }
        }
      }
    });

    _this.scrollChangeNodeToView = (0, _spauiUtils.debounce)(_this.scrollChangeNodeToView, 16);
    return _this;
  }

  _createClass(SelectionDataComponent, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var SelectionItemComponent = props.SelectionItemComponent,
          SelectionCheckAllComponent = props.SelectionCheckAllComponent,
          SelectionReverseCheckComponent = props.SelectionReverseCheckComponent;
      var onChange = props.onChange,
          value = props.value,
          multiple = props.multiple,
          max = props.max,
          onScroll = props.onScroll,
          html = props.html,
          checkAllLabel = props.checkAllLabel,
          onCheckAllChange = props.onCheckAllChange,
          checkAllIsChecked = props.checkAllIsChecked,
          reverseCheck = props.reverseCheck,
          reverseCheckLabel = props.reverseCheckLabel,
          onReverseCheckChange = props.onReverseCheckChange,
          _props$style = props.style,
          style = _props$style === void 0 ? {} : _props$style,
          valueFieldName = props.valueFieldName,
          _props$labelFieldName = props.labelFieldName,
          labelFieldName = _props$labelFieldName === void 0 ? '' : _props$labelFieldName,
          onClickItem = props.onClickItem,
          emphasize = props.emphasize,
          AppendDataComponent = props.AppendDataComponent,
          _props$classNameMap = props.classNameMap,
          classNameMap = _props$classNameMap === void 0 ? {} : _props$classNameMap,
          onMouseOutItem = props.onMouseOutItem,
          onMouseOverItem = props.onMouseOverItem,
          onMouseOverData = props.onMouseOverData,
          onMouseOutData = props.onMouseOutData,
          SelectionDetailComponent = props.SelectionDetailComponent,
          theNumberOfDisplay = props.theNumberOfDisplay,
          showIndex = props.showIndex,
          displayItemHeight = props.displayItemHeight,
          searchValue = props.searchValue,
          searchEmptyTip = props.searchEmptyTip,
          _props$dataTipTrigger = props.dataTipTriggerProps,
          dataTipTriggerProps = _props$dataTipTrigger === void 0 ? {} : _props$dataTipTrigger,
          _props$dataTipPopOver = props.dataTipPopOverProps,
          dataTipPopOverProps = _props$dataTipPopOver === void 0 ? {} : _props$dataTipPopOver;
      var checkAllData = {};
      var reverseCheckData = {};
      var showData = [];
      var appendDataComponentInstance = null;
      var selectionDetailComponentInstance = null;
      var showPlacementDiv = false;
      var beforePlacementDiv = null;
      var afterPlacementDiv = null;
      var result = null;
      var searchEmptyTipResult = null; // 有搜索对应的数据都进行展示且放在最后面

      showData = (0, _index.getShowData)(props);
      showPlacementDiv = theNumberOfDisplay > 0 && showData.length > theNumberOfDisplay; // 全选对应的文案与值

      checkAllData[labelFieldName] = checkAllLabel;
      checkAllData[valueFieldName] = 'SELECT_CHECK_ALL'; // 反选对应的文案与值

      reverseCheckData[labelFieldName] = reverseCheckLabel;
      reverseCheckData[valueFieldName] = 'SELECT_REVERSE_CHECK_ALL';

      if (typeof AppendDataComponent !== 'undefined') {
        if ((0, _spauiUtils.isReactNode)(AppendDataComponent)) {
          appendDataComponentInstance = AppendDataComponent;
        } else {
          appendDataComponentInstance = _react["default"].createElement(AppendDataComponent, props);
        }
      }

      if (typeof SelectionDetailComponent !== 'undefined') {
        if ((0, _spauiUtils.isReactNode)(SelectionDetailComponent)) {
          selectionDetailComponentInstance = SelectionDetailComponent;
        } else {
          selectionDetailComponentInstance = _react["default"].createElement(SelectionDetailComponent, _extends({}, props, props.SelectionDetailComponentProps || {}, {
            classNameMap: classNameMap
          }));
        }
      }

      if (showData.length < 1 && searchValue && searchEmptyTip) {
        if (typeof searchEmptyTip === 'number' || typeof searchEmptyTip === 'string') {
          searchEmptyTipResult = _react["default"].createElement("div", {
            className: "selection-tips",
            style: {
              position: 'static',
              display: 'block'
            }
          }, searchEmptyTip);
        } else {
          searchEmptyTipResult = searchEmptyTip;
        }
      }

      if (showPlacementDiv) {
        beforePlacementDiv = _react["default"].createElement("li", {
          "data-showindex": showIndex,
          style: {
            height: "".concat(showIndex * displayItemHeight, "px")
          }
        });
        afterPlacementDiv = _react["default"].createElement("li", {
          style: {
            height: "".concat((showData.length - (showIndex + theNumberOfDisplay)) * displayItemHeight, "px")
          }
        });
      }

      result = _react["default"].createElement("ul", {
        className: classNameMap.SelectDataClassName,
        onScroll: onScroll,
        ref: this.setScrollContainerRef,
        style: style,
        onMouseOver: onMouseOverData,
        onMouseOut: onMouseOutData
      }, (0, _index.isShowCheckAll)(props) ? _react["default"].createElement(SelectionCheckAllComponent, _extends({}, props, props.SelectionCheckAllComponentProps || {}, {
        classNameMap: classNameMap,
        multiple: multiple,
        checked: checkAllIsChecked,
        data: checkAllData,
        value: value,
        htmlable: html,
        html: html,
        onClick: onCheckAllChange
      })) : null, multiple && reverseCheck && (typeof max === 'undefined' || max < 1) ? _react["default"].createElement(SelectionReverseCheckComponent, _extends({}, props, props.SelectionReverseCheckComponentProps || {}, {
        classNameMap: classNameMap,
        multiple: multiple,
        checked: checkAllIsChecked,
        data: reverseCheckData,
        value: value,
        htmlable: html,
        html: html,
        onClick: onReverseCheckChange
      })) : null, beforePlacementDiv, showData.map(function (item, index) {
        var theItemValue = typeof item[valueFieldName] !== 'undefined' ? item[valueFieldName] : item;

        var onClickSelectItem = function onClickSelectItem(event, itemData, itemValue) {
          if ((0, _spauiUtils.isFunction)(onClickItem)) {
            onClickItem(event, itemData);
          }

          if ((0, _spauiUtils.isFunction)(onChange)) {
            onChange(event, itemValue);
          }
        };

        var onMouseOutSelectItem = function onMouseOutSelectItem(event, itemData) {
          if ((0, _spauiUtils.isFunction)(onMouseOutItem)) {
            onMouseOutItem(event, itemData);
          }
        };

        var onMouseOverSelectItem = function onMouseOverSelectItem(event, itemData) {
          if ((0, _spauiUtils.isFunction)(onMouseOverItem)) {
            onMouseOverItem(event, itemData);
          }
        };

        if (showPlacementDiv && (index < showIndex || index > showIndex + theNumberOfDisplay)) {
          return null;
        }

        var selectItemElement = _react["default"].createElement(SelectionItemComponent, _extends({}, props, props.SelectionItemComponentProps || {}, {
          "data-index": index,
          key: "".concat(theItemValue, "__spaui___").concat(index),
          value: value,
          data: emphasize(item, props),
          onClick: function onClick(event) {
            return onClickSelectItem(event, item, theItemValue);
          },
          onMouseOut: function onMouseOut(event) {
            return onMouseOutSelectItem(event, item, theItemValue);
          },
          onMouseOver: function onMouseOver(event) {
            return onMouseOverSelectItem(event, item, theItemValue);
          }
        }));

        if (item.tip) {
          return _react["default"].createElement(_spauiPopover.OverlayTrigger, _extends({
            key: "".concat(theItemValue, "__spaui___").concat(index, "_overlaytrigger"),
            trigger: "hover",
            placement: "right",
            offsetData: tipDefaultOffsetData,
            overlay: _react["default"].createElement(_spauiPopover.PopOver, dataTipPopOverProps, item.tip)
          }, dataTipTriggerProps), selectItemElement);
        }

        return selectItemElement;
      }), afterPlacementDiv, appendDataComponentInstance);

      if (selectionDetailComponentInstance) {
        result = _react["default"].createElement("div", {
          className: props.selectionDetailWrapClassName || ''
        }, result, selectionDetailComponentInstance, searchEmptyTipResult);
      } else if (searchEmptyTipResult) {
        result = _react["default"].createElement("div", {
          className: props.selectionDetailWrapClassName || ''
        }, result, searchEmptyTipResult);
      }

      return result;
    }
  }]);

  return SelectionDataComponent;
}(_react["default"].PureComponent);

var _default = SelectionDataComponent;
exports["default"] = _default;